import { initAllHeroSwipers } from './init-hero-swiper';

function boot() {
	initAllHeroSwipers();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
